import React, {useState} from "react"
import {Box, Button, IconButton, Typography} from "@mui/material"
import {styled} from "@mui/material/styles"
import {CirclePlus, Trash} from "lucide-react"
import Content from "../../../components/Content"
import {checkConditionalMerkmalInRubrik} from "../../../misc/condition-merkmal"

const Row = styled(Box)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.Row)
const Title = styled(Typography)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.Title)
const AddButton = styled(Button)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.AddButton)
const DetailArea = styled(Box)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.DetailArea)
const InlineIconButton = styled(IconButton)(({theme}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.IconButton)
const IndexBadge = styled(Button, {
    shouldForwardProp: (prop) => prop !== "active",
})(({theme, active}) => theme.FRAGEKATALOG.QuestionMulti.BORDERLESS.IndexBadge(active))

const QuestionMultiBorderless = ({
    questiongroup,
    questionList,
    value,
    currentIndex,
    setCurrentIndex,
    handleAdd,
    handleDelete,
    widgetLists,
    getDataFromPointer,
}) => {
    const [open, setOpen] = useState(false)

    const buttonLabel = value.length === 0
        ? "Hinzufügen"
        : open ? "Schließen" : "Öffnen"

    const handleToggle = () => {
        if (value.length === 0) {
            handleAdd()
            setOpen(true)
        } else {
            setOpen((prev) => !prev)
        }
    }

    return (
        <Box>
            <Row>
                <Title>{questiongroup.longname}</Title>
                <AddButton
                    variant="outlined"
                    onClick={handleToggle}>
                    {buttonLabel}
                </AddButton>
            </Row>
            {open && value.length > 0 && (
                <DetailArea>
                    <Box sx={{display: "flex", justifyContent: "flex-end", gap: 1}}>
                        <InlineIconButton
                            onClick={handleAdd}
                            color="primary">
                            <CirclePlus size={20} />
                        </InlineIconButton>
                        <InlineIconButton
                            onClick={handleDelete}
                            color="primary">
                            <Trash size={20} />
                        </InlineIconButton>
                    </Box>
                    <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                        {widgetLists.map((widget, index) => (
                            checkConditionalMerkmalInRubrik(questionList[index], questiongroup, getDataFromPointer, currentIndex) && <Content
                                key={`${currentIndex}-${index}`}
                                child={widget}
                            />
                        ))}
                    </Box>
                    <Box sx={{display: "flex", flexWrap: "wrap", gap: 1}}>
                        {value.map((_, index) => (
                            <IndexBadge
                                key={index}
                                active={index === currentIndex}
                                onClick={() => setCurrentIndex(index)}>
                                {index + 1}
                            </IndexBadge>
                        ))}
                    </Box>
                </DetailArea>
            )}
        </Box>
    )
}

export default QuestionMultiBorderless
